import angular from 'angular';
import { default as docDataService } from 'app/services/data/doc.data.service';
import documentManagementDialog from './dialog.documentManagementDialog';
import controller from './document-management.controller';
import directive from './document-management.directive';

const library = require('@safe-systems/ss-ui-components');

const {
  loaderService,
  ssDialogService,
} = library;

export default angular.module('app.components.global.documentManagement', [
  ssDialogService,
  loaderService,
  docDataService,
  documentManagementDialog,
])
  .directive('documentManagement', directive)
  .controller('DocumentManagementController', controller)
  .name;

console.log('app.components.global.documentManagement created');
